import { lowerCase, snakeCase, random } from 'lodash'

export default function (label) {
    const id = random(100, 999)

    return label ? id + '_' + snakeCase(lowerCase(label)) : id
}
